import React, { useState } from "react";
import { apiError } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { toast } from "sonner";
import { Check, Loader2, Pencil, X } from "lucide-react";

interface Props {
  date: string;
  onSave: (date: string) => Promise<void>;
  testid: string;
}

export const DateEditInline: React.FC<Props> = ({ date, onSave, testid }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState((date || "").slice(0, 10));
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (!value) return;
    setSaving(true);
    try {
      await onSave(value);
      toast.success("Fecha actualizada");
      setEditing(false);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setSaving(false);
    }
  };

  if (!editing) {
    return (
      <button
        type="button"
        onClick={() => { setValue((date || "").slice(0, 10)); setEditing(true); }}
        data-testid={`${testid}-edit`}
        className="group inline-flex items-center gap-1 text-slate-400 transition-colors hover:text-[#DD0000]"
        title="Editar fecha"
      >
        {fmtDate(date)}
        <Pencil className="h-3 w-3 opacity-60 group-hover:opacity-100" />
      </button>
    );
  }

  return (
    <span className="inline-flex items-center gap-1">
      <input
        type="date"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        data-testid={`${testid}-input`}
        className="h-7 border border-slate-300 px-1.5 text-xs text-slate-700"
      />
      <button type="button" onClick={save} disabled={saving} data-testid={`${testid}-save`} className="p-1 text-emerald-600 hover:text-emerald-700">
        {saving ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />}
      </button>
      <button type="button" onClick={() => setEditing(false)} data-testid={`${testid}-cancel`} className="p-1 text-slate-400 hover:text-slate-600">
        <X className="h-3.5 w-3.5" />
      </button>
    </span>
  );
};
